module.exports = __webpack_public_path__ + "img/lezhi01.ac224740.png";